module.exports = __webpack_public_path__ + "img/92194.d71a7fe7.svg";